import React from 'react';
import { hashCode } from '@lib/string';
import LottieAnimation from '@components/shared/LottieAnimation/LottieAnimation';
import styles from './Steps.module.scss';
import { IStep } from './IStep';

export interface ISteps {
  className?: string;
  steps: IStep[];
}

export default function Steps({
  className = '',
  steps
}: ISteps) {
  return (
    <div className={className}>
      {steps.map((step) => (
        <div className={styles.Row} key={hashCode(step.eyebrow)}>
          <div className={`${styles.Column} ${styles.ImageColumn}`}>
            <LottieAnimation
              src={step.animatedImage}
              width="100%"
            />
          </div>
          <div
            className={`${styles.Column}
            ${styles.TextColumn}`}
          >
            <h4 className={styles.Overline}>{step.eyebrow}</h4>
            <p className={styles.Title1}>{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
